import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { getUrlParameter } from '../../global/data/url.js'
import initComponents from '../../global/components/index.js'
import {
  getFund,
  getFullHoldings,
  getProductListByCategory,
  getProductListByCusip,
} from './Data/FundDetailsDataSource.js'
import { isDisplayFullHoldingsForFund } from './Helpers/FundUtility.js'
import FundDetails from './FundDetails.jsx'
import EmailSubscriptionCenterModal from '../EmailSubscriptionCenter/Modal/EmailSubscriptionCenterModal.jsx'
import { isLoggedIntoSubscriptionCenter } from '../../global/authentication/authentication-manager.js'
import initStickyHeader from './Modules/FundHeader/index.js'
import { setMeta } from './Helpers/Meta.js'
import CampaignFundDetails from '../InteractionStudio/CampaignFundDetails.jsx'

import { useSubscriptionModelHook } from './Data/SubscriptionCenterHook.js'
import { triggerDigitalData } from './Helpers/Analytics.js'
import { autoOpenIStudioSlide } from '../InteractionStudio/InteractionStudioUtility.js'
import { featureFlag } from '../../global/utilities/feature-flag.js'
import { fetchTooltipData } from '../Tooltip/tooltipUtil.js'
import {
  getProductPropertyByValue,
  MODEL_PORTFOLIOS_PRODUCTS,
} from './Helpers/FundTypes.js'

function FundDetailsContainer({ etfRegulatoryMessage, component, page }) {
  const urlStructure = window.location.pathname.split('/')
  const productType =
    getProductPropertyByValue(
      'path',
      urlStructure[
        urlStructure.findIndex((i) => i === 'investment-products') + 1
      ],
      'productListType'
    ) || null

  const cusip = getUrlParameter('cusip')
  const mock = getUrlParameter('mock')
  let mockOptions = null
  if (mock) {
    mockOptions = {
      dataType: getUrlParameter('dataType'),
    }
  }

  const [fund, setFund] = useState(null)
  const [productList, setProductList] = useState([])
  const [fullHoldings, setFullHoldings] = useState(null)

  const [
    subscriptionModel,
    getFundSubscriptions,
    setFundSubscription,
    setShowEmailSubscriptionCenterModal,
    setSubscriptions,
    handleCloseModalClick,
    getSubscriptions,
    getModalName,
    updateEmailsSubscriptionData,
    getFundSubscriptionsActiveLiterature,
  ] = useSubscriptionModelHook()

  useEffect(() => {
    if (!fund) {
      initializeData()
    } else {
      initStickyHeader()
      window.prerenderReady = true
    }
  }, [fund])

  const initializeData = async () => {
    const isModelPortfolios = productType === MODEL_PORTFOLIOS_PRODUCTS
    const getProductList = isModelPortfolios
      ? getProductListByCategory
      : getProductListByCusip
    const productParam = isModelPortfolios ? productType : cusip

    await fetchTooltipData()
    const [_fund, _productList] = await Promise.all([
      getFund(cusip, mock, mockOptions),
      getProductList(productParam),
    ])

    if (
      _productList.value.products.length < 1 &&
      _fund.productType === MODEL_PORTFOLIOS_PRODUCTS
    ) {
      const modelPorfoliosProductList = await getProductListByCategory(
        MODEL_PORTFOLIOS_PRODUCTS
      )

      setProductList(modelPorfoliosProductList)
    } else {
      setProductList(_productList)
    }

    setFund(_fund)
    setMeta(_fund)
    triggerDigitalData(cusip, _fund)

    if (isDisplayFullHoldingsForFund(_fund)) {
      const dataType = 'FullHoldings'
      const _fullHoldings = await getFullHoldings(cusip, dataType)
      setFullHoldings(_fullHoldings)
    }

    const timer = setTimeout(()=> {
      initComponents()
      clearTimeout(timer)
    }, 1000)

    updateEmailsSubscriptionData()
  }

  const fundDetailsProps = {
    fund,
    productList,
    fullHoldings,
    subscriptionModel,
    getFundSubscriptions,
    setFundSubscription,
    setShowEmailSubscriptionCenterModal,
    setSubscriptions,
    etfRegulatoryMessage,
    getFundSubscriptionsActiveLiterature,
    component,
    page,
  }

  // Interaction Studio - if user doesn't open the slider,
  // auto open after 3 seconds
  try {
    autoOpenIStudioSlide()
  } catch (error) {
    console.error('error', error)
  }

  return (
    <>
      <FundDetails {...fundDetailsProps} />

      {subscriptionModel.showEmailSubscriptionModal && (
        <EmailSubscriptionCenterModal
          docs={getFundSubscriptions()}
          subscriptions={getSubscriptions()}
          handleCloseModalClick={handleCloseModalClick}
          isLoggedIn={isLoggedIntoSubscriptionCenter()}
          name={getModalName()}
        />
      )}

      {/* interaction studio */}
      <div id="is-fund-detail-content-zone-6"></div>
      {featureFlag('interactionstudio') && (
        <CampaignFundDetails
          header="SUGGESTED SOLUTIONS AND STRATEGIES"
          fundName="Columbia Balanced Fund"
          url="/investment-products/mutual-funds/Columbia-Balanced-Fund/Class-Institutional/details/?cusip=19765P430"
          descriptionText="Interested in an enhanced return potential? Then you may be interested in the"
        />
      )}
    </>
  )
}

FundDetailsContainer.propTypes = {
  etfRegulatoryMessage: PropTypes.object,
}

export default FundDetailsContainer
